import { ApplicationMilestone, Applications, TicketAttributes } from '@copetence/shared';
import { API } from 'handlers/APIHandler';
import { API as APITypes } from '@copetence/shared';
import { create } from 'zustand'

type ListTicketsState = {
  tickets: TicketAttributes[];
  milestones: ApplicationMilestone[];
}

type ListTicketsActions = {
  sync: (appId: string) => void
  clear: () => void
}

const initialListTicketsState: ListTicketsState = {
  tickets: [],
  milestones: []
}

export const useListTicketsState = create<ListTicketsState & ListTicketsActions>()((set, get) => ({
  ...initialListTicketsState,
  sync: (appId: string) => {
    if (!appId) return

    set({
      milestones: [...(Applications.find(a => a.id === appId)?.milestones || []), { id: "Default Milestone", name: "Default Milestone", description: "Default Milestone", completed: false, defaultMilestone: false }]
    });

    API.get<{ tickets: TicketAttributes[] }>(`/tickets/list/${appId}`)
      .then((response) => {
        if (response instanceof APITypes.Error) {
          console.error(response)
          return
        }
        set({ tickets: response.data.tickets })
        console.log(response)
      })
      .catch((error) => {
        console.error("Error fetching tickets:", error);
      });
  },
  clear: () => set({ ...initialListTicketsState })
}))